import RegisterVenue from "./RegisterVenue"

export default RegisterVenue;